import { createSelector } from '@reduxjs/toolkit'
import { FormRootState } from './formStore'
import { Form, parseForm } from '@fusion-advantage/formlib'

export const selectForm = createSelector(
	(state: FormRootState) => state.render.form?.flowXml,
	(flowXml): Form => {
		return flowXml ? parseForm(flowXml) : {
			doc: null,
			rootNode: null,
			pages: [],
			calcScripts: [],
			concepts: {},
			persisters: {},
			returnedEntities: null,
			oncologyData: [],
			ulcerData: [],
		}
	}
)

export const selectExport = (state: FormRootState) => state.render.form?.export
